import { render } from "./homeslide4.vue?vue&type=template&id=de3f9f5e&scoped=true"
import script from "./homeslide4.vue?vue&type=script&lang=js"
export * from "./homeslide4.vue?vue&type=script&lang=js"

import "./homeslide4.vue?vue&type=style&index=0&id=de3f9f5e&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de3f9f5e"]])

export default __exports__